import { useState } from "react";
import { Conta } from "../../../model/Conta";
import styles from "./styles.module.css";
import CampoSenha from "../../../components/Campo/CampoSenha";

type Props = {
  passarPagina: Function;
  setNovaSenha: React.Dispatch<React.SetStateAction<string | undefined>>;
};

function CadastroSenha({ passarPagina, setNovaSenha }: Props) {
  const [senha, setSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [showError, shouldShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  return (
    <>
      <h2>
        3. Cadastre a <strong>Senha</strong> do Representante
      </h2>

      <h3 className={styles.login}>
        * O Login do representante será o CPF dele
      </h3>

      <CampoSenha
        title="Senha"
        placeholder="Digite sua senha"
        customValidity="Preencha com sua senha"
        setter={setSenha}
        value={senha}
      />

      <CampoSenha
        title="Confirmar Senha"
        placeholder="Confirme a sua senha"
        customValidity="Confirme a sua senha"
        setter={setConfirmarSenha}
        value={confirmarSenha}
      />

      {showError && <span className={styles.error}>*{errorMessage}</span>}

      <div className="flex justify-between">
        <button
          className={styles.passarTelaBtn}
          onClick={(e) => {
            e.preventDefault();
            passarPagina(1);
          }}
        >
          ❮❮ Anterior
        </button>
        <input
          className={styles.sendBtn}
          type="submit"
          value="⤷ Finalizar Cadastro"
          onClick={() => {
            if (
              !(senha.length >= 8) &&
              !/[A-Z]/g.test(senha) &&
              !/[0-9]/g.test(senha) &&
              !/[a-z]/g.test(senha) &&
              !/[^A-Za-z0-9]/g.test(senha)
            ) {
              setErrorMessage(
                "A Senha deve ter 8 ou mais digitos e ser composta por pelo menos: Uma letra maiúscula, Uma letra minuscula, Um numero, e um caractér especial"
              );
              return;
            }
            if (senha !== confirmarSenha) {
              setErrorMessage(
                "Os campos Senha e Confirmar Senha devem coincidir"
              );
              shouldShowError(true);
              return;
            }
            if (
              !(
                senha.length >= 8 &&
                /[A-Z]/g.test(senha) &&
                /[0-9]/g.test(senha) &&
                /[a-z]/g.test(senha) &&
                /\W|_/g.test(senha)
              )
            ) {
              setErrorMessage(
                "A senha deve conter ao menos 8 digitos, uma letra minúscula, uma letra maiúscula, um numero e um caracter especial"
              );
              shouldShowError(true);
              return;
            }
            setNovaSenha(senha);
          }}
        />
      </div>
    </>
  );
}

export default CadastroSenha;
